import type { GrupoPartesCertificado } from '../../../types/certificadoAcessosTypes';

export function SecaoPartesIntro() {
  return (
    <div className="px-[37px] pb-6">
      <p className="text-[14px] text-neutral-600">
        Identificação de cada pessoa ou empresa envolvida, com seu papel no processo.
      </p>
    </div>
  );
}

interface TabelaPartesGrupoProps {
  grupo: GrupoPartesCertificado;
}

export function TabelaPartesGrupo({ grupo }: TabelaPartesGrupoProps) {
  return (
    <div className="px-[37px] pb-[26px]">
      <div className="mb-[13px] flex items-center gap-[9px]">
        <span
          className={`h-2 w-2 rounded-[2px] ${grupo.corDestaque === 'coral' ? 'bg-coral-500' : 'bg-brand-600'}`}
        />
        <span
          className={`text-[12px] font-bold tracking-[0.8px] uppercase ${grupo.corDestaque === 'coral' ? 'text-coral-500' : 'text-brand-600'}`}
        >
          {grupo.titulo}
        </span>
      </div>
      <div className="overflow-hidden rounded-[8px] border border-solid border-neutral-200">
        <div className="bg-brand-50 grid grid-cols-[1.9fr_0.8fr_1.5fr_1.25fr] px-5 py-[11px] text-[11px] font-semibold tracking-[0.5px] text-neutral-500 uppercase">
          <div>Nome</div>
          <div>Papel</div>
          <div>Contato</div>
          <div>Documento</div>
        </div>
        {grupo.partes.map((parte) => (
          <div
            key={parte.nome}
            className="grid grid-cols-[1.9fr_0.8fr_1.5fr_1.25fr] items-center border-t border-solid border-neutral-200 px-5 py-4"
          >
            <div className="text-brand-600 pr-[14px] text-[13px] leading-[1.35] font-semibold">
              {parte.nome}
            </div>
            <div>
              <span
                className={
                  parte.papelDestacado
                    ? 'text-brand-600 bg-brand-600/10 rounded-[5px] px-[10px] py-[3px] text-[11px] font-semibold'
                    : 'rounded-[5px] border border-solid border-neutral-300 px-[10px] py-[3px] text-[11px] font-semibold text-neutral-500'
                }
              >
                {parte.papelLabel}
              </span>
            </div>
            <div className="text-[12px] leading-[1.55] text-neutral-700">
              {parte.contatos.map((contato) => (
                <div key={contato}>{contato}</div>
              ))}
            </div>
            <div className="text-[12px] whitespace-nowrap text-neutral-700">{parte.documento}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
